import { useEffect, useRef } from 'react';

const useFocus = () => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef.current]);

    return inputRef;
};
export default useFocus;
